@use "~theme/typography";
@use "~theme/breakpoints";

.link {
  @include typography.button-edit;
  color: var(--blue-01);
  text-decoration: none;
  border-bottom: 1px solid var(--blue-02);
  outline-offset: 8px;
  outline: none;
}
/*
.link:focus {
  outline: 2px solid var(--highlight-blue-at-30);
}

.link:hover {
  border-color: var(--highlight-blue);
}

.link:active {
  outline: 2px solid var(--highlight-blue-at-30);
}*/
